
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import PageTopTitle from "../../shared/PageTopTitle"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { getUserDocImage } from "../../../features/user/userSlice"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 1000px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        padding-top: 20px;
        align-items: center;
        overflow: auto;
        position: relative;
        .content{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            .photos{
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 15px;
                margin-block: 40px;
                padding-inline: 20px;
                img{
                    width: 250px;
                    height: 250px;
                    cursor: pointer;
                }
            }

            .btn-group{
                display: flex;
                align-items: center;
                margin-block: 20px;
                position: sticky;
                bottom: 0;
                justify-content: center;
                background-color: white;
                gap: 15px;
                width: 100%;
                z-index: 10;
                height: 60px;
            }
        }
        
    }

`

const AdvertShowPhotoModal = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const {selectRentalCar } = useSelector(state => state.ilanlar)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleUserDocImage = (image) => {
        if(image){
          dispatch(getUserDocImage(`${process.env.REACT_APP_API_IMG_COMPANY_URI}${image}`))
          dispatch(showModal("image"))
        }
    }
   
  return (
    <Container onClick={() => dispatch(showModal(null)) }>
        <div className="modal" onClick={(e)=>{e.stopPropagation(); dispatch(handleActiveSelect(null))}} >
            <PageTopTitle isDiffPage title={"Fotoğraflar"}/>

            <div className="content">
                <div className="photos">
                    <img onClick={()=> handleUserDocImage(selectRentalCar?.photo1)} src={`${process.env.REACT_APP_API_IMG_COMPANY_URI}${selectRentalCar?.photo1}`} alt="" />
                    <img onClick={()=> handleUserDocImage(selectRentalCar?.photo2)} src={`${process.env.REACT_APP_API_IMG_COMPANY_URI}${selectRentalCar?.photo2}`} alt="" />
                    <img onClick={()=> handleUserDocImage(selectRentalCar?.photo3)} src={`${process.env.REACT_APP_API_IMG_COMPANY_URI}${selectRentalCar?.photo3}`} alt="" />
                </div>
                <div className="btn-group">
                    <Button width="150px" handleClick={() => dispatch(showModal(null))} padding="10px" background="#fff" color={"#E85446"}>Kapat</Button>
                </div>
        </div>
        </div>
    </Container>
  )
}

export default AdvertShowPhotoModal